import React from 'react';

const LabelValuePair = ({label, value}) =>
    <p>
        {`${label}: `}
        <span className="heavy">
            {value}
        </span>
    </p>;

export default LabelValuePair;



// WEBPACK FOOTER //
// ./src/event/LabelValuePair.js